import { Section, SectionHeading } from '../ui/Section'
import { RevealGroup, RevealItem } from '../ui/Reveal'
import { SERVICES } from '../../data/services'

/* Six services as lit cards that lift toward you on hover. */
export default function Services() {
  return (
    <Section id="services">
      <SectionHeading
        eyebrow="Services"
        title="Engineering across the full product lifecycle"
        lead="From first specification to production and support — one accountable team for strategy, design, delivery and operations."
      />

      <RevealGroup each={0.07} className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:gap-6">
        {SERVICES.map((service, i) => {
          const Icon = service.icon
          return (
            <RevealItem key={service.id} className="surface surface-hover group flex flex-col rounded-3xl p-6 md:p-7">
              <div className="flex items-center justify-between">
                <span className="grid h-11 w-11 place-items-center rounded-2xl bg-primary-container text-primary-on-container shadow-[inset_0_1px_0_rgb(var(--highlight))] transition-colors duration-300 group-hover:bg-primary group-hover:text-primary-on">
                  <Icon className="h-5 w-5" strokeWidth={1.75} />
                </span>
                <span className="font-mono text-xs font-semibold tracking-[0.12em] text-ink-3">{String(i + 1).padStart(2, '0')}</span>
              </div>
              <h3 className="mt-6 text-xl font-bold text-ink">{service.title}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-ink-3">{service.description}</p>
              <ul className="mt-5 space-y-1.5 border-t border-outline-variant pt-4 font-mono text-[12.5px] text-ink-2">
                {service.features.map((f) => (
                  <li key={f} className="flex items-baseline gap-2.5">
                    <span className="h-1.5 w-1.5 shrink-0 translate-y-[-2px] rounded-full bg-primary" aria-hidden="true" />
                    {f}
                  </li>
                ))}
              </ul>
            </RevealItem>
          )
        })}
      </RevealGroup>
    </Section>
  )
}
